import type { PaletteMode } from '@mui/material';

/** The last chosen appearance, saved so startup can paint it before dataset preferences load. */
export type ThemeHint = PaletteMode | 'system';

// The inline script in index.html reads this key before the bundle loads.
export const THEME_HINT_STORAGE_KEY = 'simplifiThemeHint';

const isThemeHint = (value: unknown): value is ThemeHint => value === 'light' || value === 'dark' || value === 'system';

/** Theme keys that select the light theme; any other saved key selects the dark one. */
export const isLightThemeKey = (themeKey: string | null | undefined): boolean =>
  !themeKey || themeKey === 'muiDefault' || themeKey === 'simplifiDefault';

export const themeKeyToHint = (themeKey: string | null | undefined): ThemeHint => {
  if (themeKey === 'system-appearance') return 'system';
  return isLightThemeKey(themeKey) ? 'light' : 'dark';
};

export const resolveThemeHint = (hint: ThemeHint, systemColorScheme: PaletteMode): PaletteMode =>
  hint === 'system' ? systemColorScheme : hint;

export function readThemeHint(): ThemeHint | undefined {
  try {
    const value = window.localStorage.getItem(THEME_HINT_STORAGE_KEY);
    return isThemeHint(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function writeThemeHint(hint: ThemeHint): void {
  try {
    window.localStorage.setItem(THEME_HINT_STORAGE_KEY, hint);
  } catch {
    // Blocked storage leaves startup on the system setting.
  }
}
